import { Link } from "react-router-dom";
import "../styles/NotFound.css"; 

function NotFound() {
  return (
    <div className="not-found-container">
      <img
        src="https://lider.tutorandy.xyz/images/logoPw.png"
        alt="Logo Agencia Pretty Woman"
      />
      <h1>❌ 404</h1>
      <p>Página no encontrada</p>
      <Link to="/">Volver al Inicio</Link>
    </div>
  );
}

export default NotFound;
